import { z } from 'zod';
import { naicsCodeSchema, baseNaicsCodeSchema } from '../../enums.mjs';
import { naicsCodeId } from '../opaque.mjs';

const naicsCodeRowSchema = z.object({
    id: naicsCodeId,
    code: naicsCodeSchema,
    label: z.string().min(1),
    versionYear: z.number().int(),
});
const naicsCodeKey = (item) => typeof item === "string" ? item : `${item.code}:${item.versionYear}`;
var NaicsCodes;
(function (NaicsCodes) {
    function unique(ids) {
        return [...new Set(ids)];
    }
    NaicsCodes.unique = unique;
    function areSame(before, after) {
        const previous = unique(before.map(naicsCodeKey));
        const next = unique(after.map(naicsCodeKey));
        if (previous.length !== next.length)
            return false;
        const nextSet = new Set(next);
        return previous.every((key) => nextSet.has(key));
    }
    NaicsCodes.areSame = areSame;
    function diff(before, after) {
        const previous = new Set(before);
        const next = new Set(after);
        const added = [...next].filter((id) => !previous.has(id));
        const removed = [...previous].filter((id) => !next.has(id));
        return { added, removed, changeCount: added.length + removed.length };
    }
    NaicsCodes.diff = diff;
})(NaicsCodes || (NaicsCodes = {}));
const toBaseNaicsCodeString = (naicsCode) => {
    let baseNAICSCode = naicsCode.slice(0, 6);
    if (baseNAICSCode.endsWith("0")) {
        baseNAICSCode = baseNAICSCode.slice(0, -1);
    }
    return baseNAICSCode;
};
const getBaseNaicsCode = (naicsCode) => baseNaicsCodeSchema.parse(toBaseNaicsCodeString(naicsCode));
const toBaseNAICSCodeSchema = z
    .string()
    .transform(toBaseNaicsCodeString)
    .pipe(baseNaicsCodeSchema);
const getNAICSCodeLabelGroups = (naicsCodeIds, groupMap) => {
    const naicsCodeGroupsLabels = new Map();
    groupMap.forEach((group) => {
        const matchedLabels = [];
        group.subCodes.forEach((entry, id) => {
            if (naicsCodeIds.has(id))
                matchedLabels.push(entry.label);
        });
        if (matchedLabels.length === 0)
            return;
        const groupLabels = naicsCodeGroupsLabels.get(group.label) ?? {
            label: group.label,
            groupSubCodeCount: group.subCodes.size,
            subCodesLabels: [],
        };
        groupLabels.subCodesLabels = [...new Set([...groupLabels.subCodesLabels, ...matchedLabels])];
        naicsCodeGroupsLabels.set(group.label, groupLabels);
    });
    return [...naicsCodeGroupsLabels.values()];
};

export { NaicsCodes, getBaseNaicsCode, getNAICSCodeLabelGroups, naicsCodeRowSchema, toBaseNAICSCodeSchema };
